//#region IMPORT
import React, { useEffect } from 'react';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { getColumnDefs1 } from './SAP_BASIC_02_ColumnDefs';
import FileUploadDialog from '../../../../Components/FileUploadDialog/FileUploadDialog';
import SAP_BASIC_02_EvaluationModal from './SAP_BASIC_02_EvaluationModal';
//#endregion

function SAP_BASIC_02(props) {
  //#region 변수
  //#endregion

  //#region 웹
  // 안전보건관리책임자 선임서 그리드 컬럼
  const columnDefs1 = getColumnDefs1(props);

  //#endregion

  //#region AuthButton 이벤트
  useEffect(() => {
    if (props.filterClick2) {
      if (!props.validateSelection()) {
        props.setFilterClick2(false);
        return;
      }
      props.gridRef1.current.api.setQuickFilter(props.searchText);
      props.setFilterClick2(false);
    }
    if (props.searchClick2) {
      props.ResetLogic1();
      if (!props.validateSelection()) {
        props.setSearchClick2(false);
        return;
      }

      props.setSearchClick2(false);
    }

    if (props.saveClick2) {
      if (!props.validateSelection()) {
        props.setSaveClick2(false);
        return;
      }

      props.Save1();
      props.setSaveClick2(false);
    }

    if (props.printClick2) {
      if (!props.validateSelection()) {
        props.setPrintClick2(false);
        return;
      }
      props.PrintLogic1();
      props.setPrintClick2(false);
    }
    if (props.listClick2) {
      if (!props.validateSelection()) {
        props.setListClick2(false);
        return;
      }

      props.setModalToggle3(true);
      props.SearchLogic4();
      props.setListClick2(false);
    }
  }, [
    props.filterClick2,
    props.searchClick2,
    props.addClick2,
    props.saveClick2,
    props.deleteClick2,
    props.printClick2,
    props.listClick2,
  ]);
  //#endregion
  return (
    <>
      <BusinessGridCommon
        title1={'안전보건 조직 구성 기본정보'}
        gridId={props.gridId1}
        previewRender={props.PreviewRender}
        getRowId={(params) => {
          return params.data.no;
        }}
        gridRef={props.gridRef1}
        addYn1="N"
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.Search1();
        }}
        deleteYn1="N"
        editable={false}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        onSelectionChanged={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);
          props.selectedRowNosRef1.current = new Set(
            selectedData.map((r) => r.no)
          );
          props.setSelectedRowData1(selectedData);
        }}
        onCellValueChanged={(e) => {
          const key = e.data.no;
          const colId = e.column?.getColId?.();

          let rowToUpdate = { ...e.data, editYn: 'Y' };
          if (colId === 'position') {
            rowToUpdate = {
              ...rowToUpdate,
              fileName: '',
              filePath: '',
              saveName: '',
              manageDate: '',
            };
            e.api?.applyTransaction?.({ update: [rowToUpdate] });
            // 미리보기 영역 이미지 초기화: 선택된 행이 변경된 행이면 selectedRowData1도 갱신
            props.setSelectedRowData1?.((prev) =>
              prev.map((row) => (row.no === key ? rowToUpdate : row))
            );
          }

          props.setChangedRowData1?.((prev) => {
            const filtered = prev.filter((row) => row.no !== key);
            return [...filtered, rowToUpdate];
          });
        }}
      />

      {/* 평가표 팝업 */}
      {props.evaluationModalToggle && (
        <SAP_BASIC_02_EvaluationModal
          evaluationModalToggle={props.evaluationModalToggle}
          setEvaluationModalToggle={props.setEvaluationModalToggle}
          setSelectedEvaluationData={props.setSelectedEvaluationData}
          selectedEvaluationData={props.selectedEvaluationData}
          evaluationListData={props.evaluationListData}
          setEvaluationListData={props.setEvaluationListData}
          selectedEvaluationItem={props.selectedEvaluationItem}
          setSelectedEvaluationItem={props.setSelectedEvaluationItem}
          evaluationDetailData={props.evaluationDetailData}
          setEvaluationDetailData={props.setEvaluationDetailData}
          handleEvaluationSave={props.handleEvaluationSave}
          selectedRowNosRef2={props.selectedRowNosRef2}
          lastCheckedIndexRef2={props.lastCheckedIndexRef2}
          gridRef2={props.gridRef2}
          HandleRowSelection2={props.HandleRowSelection2}
          HandleAddClick={props.HandleAddClick}
          updateCurrentRowData1={props.updateCurrentRowData1}
          Save2={props.Save2}
          changedModalRowData2={props.changedModalRowData2}
          setChangedModalRowData2={props.setChangedModalRowData2}
          selectedRowData={props.selectedRowData1}
          Search2={props.Search2}
          currentRowIndexRef2={props.currentRowIndexRef2}
          MarkedForDeletion1={props.MarkedForDeletion1}
          RestoreRow1={props.RestoreRow1}
          DeleteNewRow1={props.DeleteNewRow1}
          PrintLogic2={props.PrintLogic2}
          isEvaluationReadOnly={props.isEvaluationReadOnly}
          codes={props.codes}
          ResolveEvaluationItemDefaults={props.ResolveEvaluationItemDefaults}
        />
      )}

      {/* 파일 업로드 팝업 */}
      {props.fileModalToggle && (
        <FileUploadDialog
          open={props.fileModalToggle}
          onClose={() => props.setFileModalToggle(false)}
          gridRef={props.gridRef1}
          selectedRowData={props.selectedRowData1}
          setSelectedRowData={props.setSelectedRowData1}
          setChangedRowData={props.setChangedRowData1}
          fileNameField="fileName"
          filePathField="filePath"
          saveNameField="saveName"
          SaveLogicPreview={props.SaveLogicPreview}
          DownloadLogic={props.DownloadLogic1}
          title="파일 업로드"
          filePreviewHeight="600px"
          noLimitFileName={true}
        />
      )}
    </>
  );
}

export default SAP_BASIC_02;
